/*
 * Which maternity hospital an inbound MN-CMS message came from.
 *
 * The add-pregnancy form used to pre-fill its Hospital select from this (KIN-1939). That select is
 * gone: the backend sets the pregnancy's hospital from MSH.4 of the first message it receives, so
 * guessing it on the client would be a second answer to a question the server already answers
 * (KIN-2060). What is left is the inbound panel's own "where did this come from" column.
 */

/**
 * Which site a single visit came from, for the inbound panel.
 *
 * The name when the code resolved against the MN-CMS hospital list, the bare code when it did not —
 * the backend stores an unrecognised code as-is rather than dropping it, so showing the raw value
 * is better than showing nothing and better than pretending it is unknown.
 */
export const formatSendingFacility = (message) => {
  const name = message?.sendingFacilityName?.trim();

  if (name) return name;

  const code = message?.sendingFacilityCode?.trim();

  return code || null;
};
